import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

const iconButton = {
    styleOverrides: {
        root: {
            color: colors.common.white,

            '&:hover': {
                backgroundColor: 'none',
            },
        },

        sizeLarge: {
            padding: 0,
            fontSize: typography.size.fourXl,
        },
    },
};

export default iconButton;
